export const ID = "ID";
export const Aliased_Name = "aliased_name";
export const AliasedName = "Aliased Name";
export const Actions = "Actions";
export const Title = "Aliased";
export const AddAliased = "Add Aliased";
export const EditAliased = "Edit Aliased";
export const DeleteAliased = "Delete Aliased";
export const DeleteMessage = "Are you sure you want to delete this aliased?";
